import { defineComponent as _defineComponent } from 'vue'
import MaterialIcon from 'bd-common/src/components/common/MaterialIcon.vue';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'InfoTooltip',
  props: {
  title: {
    type: String,
    default: '',
  },
  text: {
    type: String,
    default: '',
  },
},
  setup(__props) {

const props = __props;



const tooltipTitle = computed(() => `<h4>${props.title}</h4>`);

const tooltipText = computed(() => `<span>${props.text}</span>`);

const content = computed(() => `<div>${tooltipTitle.value}${tooltipText.value}</div>`);

const tooltipObject = computed(() => {
  return {
    html: true,
    customClass: 'info-tooltip',
    placement: 'top',
  };
});

return { __sfc: true,props, tooltipTitle, tooltipText, content, tooltipObject, MaterialIcon }
}

})